import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ApiCall from '../../utils/Api';
import { CircularProgress, Alert, Button } from '@mui/material';
import { convertDateFormat, extractTimeFromTimestamp } from '../../utils/services';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import components from '../../components';

const FundSubscriberProfileTable = () => {
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [UpdateCount, setUpdateCount] = useState(0);

  useEffect(() => {
    const fetchProfile = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await ApiCall.SECURE_API.get('/fundSubscriber/profile');
        setProfileData(response.data.data);
      } catch (err) {
        console.error('Error fetching profile:', err);
        setError('Failed to fetch profile information');
        toast.error('Failed to fetch profile information');
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, [UpdateCount]);

  const viewAccounts = async () => {
    try {
      // Get wallet addresses from API (this works without MetaMask connection)
      const data = await ApiCall.SECURE_API.get("/user/GetWalletAddresses");
      
      const WalletsIds = data.data.data || [];
      let connectedAccounts = [];
      
      // Try to get connected accounts from MetaMask (only if available)
      if (window.ethereum) {
        try {
          connectedAccounts = await window.ethereum.request({ method: 'eth_accounts' });
        } catch (error) {
          // MetaMask is not connected, but we can still show wallet addresses
        }
      }

      // Show wallet addresses dialog (keeping original style)
      Swal.fire({
        title: "Wallet Addresses",
        html: `
          <div style="max-height: 400px; overflow-y: auto; padding: 30px">
            <ul style="list-style-type: none; padding: 0; margin: 0;">
              ${WalletsIds.map((item) => {
                const isConnected = connectedAccounts.some((item2) => item2.toLowerCase() === item.toLowerCase());
                const statusHTML = isConnected 
                  ? '<span style="font-size: 12px;">Connected</span>'
                  : '';
                return `<li style="margin-bottom: 10px; display: flex; justify-content: space-between; align-items: center;">
                  <span>${item}</span>
                  ${statusHTML}
                </li>`;
              }).join("")}
            </ul>
          </div>
        `,
        width: '800px',
        showCloseButton: true,
        showConfirmButton: false,
      });
    } catch (error) {
      toast.error('Failed to load wallet addresses');
    }
  };

  if (loading) return <CircularProgress />;
  if (error) return <Alert severity="error">{error}</Alert>;
  if (!profileData) return <Alert severity="info">No profile data available</Alert>;

  return (
    <TableContainer component={Paper} style={{ borderRadius: 9 }}>
      <Table sx={{ minWidth: 650 }} aria-label="fund subscriber profile table">
        <TableHead style={{ backgroundColor: 'Black' }}>
          <TableRow>
            <TableCell align="center" style={{ color: 'white' }}>Created At</TableCell>
            <TableCell align="center" style={{ color: 'white' }}>Name</TableCell>
            <TableCell align="center" style={{ color: 'white' }}>Email</TableCell>
            <TableCell align="center" style={{ color: 'white' }}>Status</TableCell>
            <TableCell align="center" style={{ color: 'white' }}>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell align="center">
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <span style={{ fontWeight: 600 }}>
                  {convertDateFormat(profileData?.createdAt)}
                </span>
                <span style={{ color: "gray" }}>
                  {extractTimeFromTimestamp(profileData?.createdAt)}
                </span>
              </div>
            </TableCell>
            <TableCell align="center">
              {profileData?.firstName} {profileData?.lastName}
            </TableCell>
            <TableCell align="center">
              {profileData?.email}
            </TableCell>
            <TableCell align="center">
              <span style={{ 
                color: profileData?.status === 'active' ? 'green' : 'grey',
                fontWeight: 'bold'
              }}>
                {profileData?.status === 'active' ? 'Active' : 'Inactive'}
              </span>
            </TableCell>
            <TableCell align="center">
              <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                <Button
                  onClick={viewAccounts}
                  variant="outlined"
                  size="small"
                >
                  View Accounts
                </Button>
                <components.Provider_Permissions_Detail_Dialog.fundSubscriberEditProfile 
                  setUpdateCount={setUpdateCount} 
                  UpdateCount={UpdateCount}  
                  imgurl={profileData?.profileImage}  
                  firstName={profileData?.firstName} 
                  lastName={profileData?.lastName}
                  email={profileData?.email}
                />
              </div>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default FundSubscriberProfileTable;
